<template>
  <div class="queryDiv">
    <slot name="left"></slot>
    <el-button type="primary" icon="el-icon-plus" size="small" class="queryButton" @click="addDeal" v-if="isAdd">新增
    </el-button>
    <el-button type="danger" icon="el-icon-close" size="small" plain class="queryButton" @click="delAllDeal"
               v-if="isDelAll">批量删除
    </el-button>
    <div style="margin-left: 1.5rem;" v-if="isSelect">
      <span class="qsdTxt" v-if="curSelectLabel">{{ curSelectLabel }}</span>
      <el-select v-model="curSelectValue" size="small" :placeholder="curSelectTip" @change="downSelectDeal"
                 :clearable="isSelectClear">
        <el-option
            v-for="item in selectOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
        >
        </el-option>
      </el-select>
    </div>
    <div style="margin-left: 1.5rem;" v-if="isSelect2">
      <span class="qsdTxt" v-if="curSelectLabel2">{{ curSelectLabel2 }}</span>
      <el-select v-model="curSelectValue2" size="small" :placeholder="curSelectTip2" @change="downSelectDeal2"
                 :clearable="isSelectClear2">
        <el-option
            v-for="item in selectOptions2"
            :key="item.id"
            :label="item.label"
            :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div style="margin-left: 1.5rem;" v-if="isSelect3">
      <span class="qsdTxt" v-if="curSelectLabel3">{{ curSelectLabel3 }}</span>
      <el-select v-model="curSelectValue3" size="small" :placeholder="curSelectTip3" @change="downSelectDeal3"
                 :clearable="isSelectClear3">
        <el-option
            v-for="item in selectOptions3"
            :key="item.id"
            :label="item.label"
            :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div style="margin-left: 1.5rem;" v-if="isDate">
      <span class="qsdTxt">时间</span>
      <el-date-picker
          class="qsj"
          @change="dateSelectDeal"
          size="small"
          v-model="curSelectDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
      <el-image class="qSjImg1" :src="require('../../../assets/buttonGathers/query-sj.png')"></el-image>
      <el-image class="qSjImg2" :src="require('../../../assets/buttonGathers/query-sj.png')"></el-image>
    </div>
    <el-input :placeholder="curInputTip" v-model="curInputValue" size="small" class="srInput" clearable
              v-if="isInput"></el-input>
    <el-button type="primary" size="small" class="czBut queryButton" @click="resetDeal" v-if="isReset">重置</el-button>
    <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding"
               @click="queryDeal" v-if="isQuery">搜索
    </el-button>
    <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="qgLb1"
               v-if="isLabelButton1">{{isLabelButtonText1}}
    </el-button>
    <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="exportDeal"
               v-if="isExport">
      <el-image class="qDcImg" :src="require('../../../assets/buttonGathers/query-dc.png')"></el-image>&nbsp;
      导出
    </el-button>
    <slot name="right"></slot>
  </div>

</template>

<script>
/**
 * @Author: ygh
 * @Date: 2024/3/18 14:44
 * @Description:常用查询模块分装
 */
export default {
  name: "queryGather",
  props: {
    'curInputTip': {
      type: String,
      default: '请输入查询内容',
    },
    'curSelectTip': {
      type: String,
      default: '请选择内容',
    },
    'curSelectTip2': {
      type: String,
      default: '请选择内容',
    },
    'curSelectTip3': {
      type: String,
      default: '请选择内容',
    },
    'isSelectClear': {
      type: Boolean,
      default: false,
    },
    'isSelectClear2': {
      type: Boolean,
      default: false,
    },
    'isSelectClear3': {
      type: Boolean,
      default: false,
    },
    'curSelectLabel': {
      type: String,
      default: '',
    },
    'curSelectLabel2': {
      type: String,
      default: '',
    },
    'curSelectLabel3': {
      type: String,
      default: '',
    },
    'selectOptions': {
      type: Array,
      default: () => [],
      required: false,
    },
    'selectOptions2': {
      type: Array,
      default: () => [],
      required: false,
    },
    'selectOptions3': {
      type: Array,
      default: () => [],
      required: false,
    },
    'isSelectFirst': {
      type: Boolean,
      default: false,
    },
    'isAdd': {
      type: Boolean,
      default: false,
    },
    'isDelAll': {
      type: Boolean,
      default: false,
    },
    'isSelect': {
      type: Boolean,
      default: false,
    },
    'isSelect2': {
      type: Boolean,
      default: false,
    },
    'isSelect3': {
      type: Boolean,
      default: false,
    },
    'isDate': {
      type: Boolean,
      default: false,
    },
    'isExport': {
      type: Boolean,
      default: false,
    },
    'isInput': {
      type: Boolean,
      default: true,
    },
    'isReset': {
      type: Boolean,
      default: true,
    },
    'isQuery': {
      type: Boolean,
      default: true,
    },
    'isLabelButton1': {
      type: Boolean,
      default: false,
    },
    'isLabelButtonText1': {
      type: String,
      default: '',
    },

  },
  data() {
    return {
      curInputValue: '',
      curSelectValue: '',
      curSelectValue2: '',
      curSelectValue3: '',
      curSelectDate: '',
    }
  },
  methods: {
    initDataItem(){
      let ks = new Date().toISOString().slice(0, 10);
      let js = new Date();
      js.setDate(js.getDate() + 1)
      let jsDate = js.toISOString().slice(0, 10)
      this.curSelectDate = []
      this.curSelectDate.push(ks)
      this.curSelectDate.push(jsDate)
      this.queryDeal();
    },
    resetDeal() {
      this.curSelectDate = '';
      this.curInputValue = '';
      this.curSelectValue = '';
      this.initDataItem();
      this.curSelectValue2 = '';
      this.curSelectValue3 = '';
      this.$emit('qgResetDeal', '');
      // console.log("=====resetDeal=======", this.curSelectDate);
    },
    queryDeal() {
      let params = {
        curSelectDate: this.curSelectDate,
        curInputValue: this.curInputValue,
      }
      if (this.isSelect){
        params = {
          ...params,
          curSelectValue: this.curSelectValue,
          curSelectOption: this.getCurSelectOption(1)
        }
      }
      if (this.isSelect2) {
        params = {
          ...params,
          curSelectValue2: this.curSelectValue2,
          curSelectOption2: this.getCurSelectOption(2)
        }
      }
      if (this.isSelect3) {
        params = {
          ...params,
          curSelectValue3: this.curSelectValue3,
          curSelectOption3: this.getCurSelectOption(3)
        }
      }


      this.$emit('qgQueryDeal', params);
      // console.log("=====queryDeal=======", this.curSelectDate);
    },
    qgLb1(){
      this.$emit('qgLb1Deal', '');
    },
    exportDeal() {
      let params = {
        curSelectDate: this.curSelectDate,
        curInputValue: this.curInputValue,
      }
      if (this.isSelect){
        params = {
          ...params,
          curSelectValue: this.curSelectValue,
          curSelectOption: this.getCurSelectOption(1)
        }
      }
      if (this.isSelect2) {
        params = {
          ...params,
          curSelectValue2: this.curSelectValue2,
          curSelectOption2: this.getCurSelectOption(2)
        }
      }
      if (this.isSelect3) {
        params = {
          ...params,
          curSelectValue3: this.curSelectValue3,
          curSelectOption3: this.getCurSelectOption(3)
        }
      }
      this.$emit('qgExportDeal', params);
      // console.log("=====exportDeal=======", this.curSelectDate);
    },
    dateSelectDeal() {
      let params = {
        curSelectDate: this.curSelectDate,
      }
      this.$emit('qgDateSelectDeal', params);
      // console.log("=====dateSelectDeal=======", this.curSelectDate);
    },
    addDeal() {
      this.$emit('qgAddDeal', '');
      // console.log("=====addDeal=======", this.curSelectDate);
    },
    delAllDeal() {
      this.$emit('qgDelAllDeal', '');
      // console.log("=====delAllDeal=======", this.curSelectDate);
    },
    downSelectDeal() {
      let params = {
        curSelectValue: this.curSelectValue,
        curSelectOption: this.getCurSelectOption(1),
      }
      this.$emit('qgDownSelectDeal', params);
      // console.log("=====downSelectDeal=======", this.curSelectDate);
    },
    downSelectDeal2() {
      let params = {
        curSelectValue2: this.curSelectValue2,
        curSelectOption2: this.getCurSelectOption(2),
      }
      this.$emit('qgDownSelectDeal', params);
      // console.log("=====downSelectDeal=======", this.curSelectDate);
    },
    downSelectDeal3() {
      let params = {
        curSelectValue3: this.curSelectValue3,
        curSelectOption3: this.getCurSelectOption(3),
      }
      this.$emit('qgDownSelectDeal', params);
      // console.log("=====downSelectDeal=======", this.curSelectDate);
    },
    getCurSelectOption(index) {
      if (index === 1) return this.selectOptions.filter((obj) => obj.code === this.curSelectValue);
      if (index === 2) return this.selectOptions2.filter((obj) => obj.code === this.curSelectValue2);
      if (index === 3) return this.selectOptions3.filter((obj) => obj.code === this.curSelectValue3);
    },
  },
  mounted() {
    if (this.isSelectFirst) {
      this.curSelectValue = this.selectOptions[0]['id'];
    }
    this.initDataItem();
  },
}
</script>

<style scoped>
.qsj {
  text-align: center;
  align-items: center;
  justify-content: space-between;
}

/deep/ .qsj .el-input__icon {
  display: none;
}

/deep/ .qsj input:first-of-type {

}

/deep/ .qsj input:last-of-type {
  margin-right: 1rem;
  margin-left: -2rem;

}

.qSjImg1 {
  width: 1.2rem;
  height: 1.2rem;
  position: relative;
  right: 54%;
  top: 11%;
}

.qSjImg2 {
  width: 1.2rem;
  height: 1.2rem;
  position: relative;
  right: 8%;
  top: 11%;
}

.qsdTxt {
  font-family: PingFang SC;
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2rem;
  letter-spacing: 0rem;
  color: #323232;
  margin-right: 1.4rem;
}

.qDcBtn {
  position: absolute;
  right: 4rem;
}

.qDcImg {
  width: 1.2rem;
  height: 1.2rem;
}

.srInput {
  width: 20rem;
  margin-left: 1.5rem;
  background-color: #ffffff;
  border-radius: 0rem;
  border: solid 0rem #c9c9c9;
  font-family: PingFang SC;
  font-size: 1.2rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2rem;
  letter-spacing: 0rem;
  color: #9d9d9d;
}

.queryDiv {
  height: 6rem;
  display: flex;
  align-items: center;
}

.queryButton {
  font-family: PingFang SC;
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  margin-left: 1.5rem;
}

.queryButtonPadding {
  padding-left: 2rem;
  padding-right: 2rem;
}

.czBut {
  background-color: #a8a8a8;
  border: solid 0rem #f4f4f4;
}

</style>
